const num = (value) => {
  const id = Number(value);
  return id > 0 ? id : null;
};

export function collectionItemPayload(item, index) {
  const kind = item?.itemKind || "design";
  const row = {
    itemKind: kind,
    displayOrder: index,
    isActive: item?.isActive !== false,
    isFeatured: !!item?.isFeatured,
    cardImageUrl: item?.cardImageUrl || null,
    designId: null,
    productId: null,
    productVariantId: null,
    typeId: null,
    caseStyleId: null,
  };
  if (kind === "design") row.designId = num(item?.designId);
  else if (kind === "design-type") {
    row.designId = num(item?.designId);
    row.typeId = num(item?.typeId);
    row.caseStyleId = num(item?.caseStyleId);
  } else if (kind === "product") row.productId = num(item?.productId);
  else if (kind === "variant") row.productVariantId = num(item?.productVariantId);
  return row;
}

export function visibleFields(kind) {
  if (kind === "design-type") return ["design", "phone", "caseStyle"];
  if (kind === "product") return ["product"];
  if (kind === "variant") return ["variant"];
  return ["design"];
}

export function appendUniqueItems(items, rows) {
  const keys = new Set((items || []).map(itemKey));
  const next = [...(items || [])];
  rows.forEach((row) => {
    const key = itemKey(row);
    if (keys.has(key)) return;
    keys.add(key);
    next.push(row);
  });
  return next;
}

export function designRows(ids) {
  return ids.map((id) => ({ itemKind: "design", designId: Number(id), isActive: true })).filter((row) => row.designId > 0);
}

export function productRows(ids) {
  return ids.map((id) => ({ itemKind: "product", productId: Number(id), isActive: true })).filter((row) => row.productId > 0);
}

export function syncDesignModels(items, designId, typeIds) {
  const design = num(designId);
  const wanted = [...new Set(typeIds.map((id) => Number(id)).filter((id) => id > 0))];
  const kept = (items || []).filter((item) => {
    if (item?.itemKind !== "design-type" || num(item.designId) !== design) return true;
    return wanted.includes(num(item.typeId));
  });
  const present = new Set(kept.filter((item) => item.itemKind === "design-type" && num(item.designId) === design).map((item) => num(item.typeId)));
  return [
    ...kept,
    ...wanted.filter((id) => !present.has(id)).map((id) => ({ itemKind: "design-type", designId: design, typeId: id, isActive: true })),
  ];
}

export function modelRows(designId, typeIds) {
  return typeIds.map((id) => ({
    itemKind: "design-type",
    designId: num(designId),
    typeId: Number(id),
    isActive: true,
  })).filter((row) => row.designId && row.typeId > 0);
}

function itemKey(item) {
  return [
    item?.itemKind,
    num(item?.designId) || "",
    num(item?.productId) || "",
    num(item?.productVariantId) || "",
    num(item?.typeId) || "",
    num(item?.caseStyleId) || "",
  ].join(":");
}
